module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "qzfx-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("成为会员后，我们会将关键求职数据以图表形式呈现给您。同时，我们会针对每日的求职效果给出效果打分和建议，帮助您以最快最省事的方式达到想要的效果。")])]), _vm._v(" "), _c('div', {
    staticClass: "qzfx-bg"
  }, [_c('img', {
    staticClass: "qzfx-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-qzfx.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("求职分析")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：成为会员后，我们会将关键求职数据以图表形式呈现给您。同时，我们会针对每日的求职效果给出效果打分和建议，帮助您以最快最省事的方式达到想要的效果。")])]), _vm._v(" "), _c('div', {
    staticClass: "qzfx-bg"
  }, [_c('img', {
    staticClass: "qzfx-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-qzfx.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40be959e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/QzfxDialog.vue
// module id = E/n+
// module chunks = 1